import React from 'react';
import PropTypes from 'prop-types';

import {NimbusLink} from '../nimbus/nimbusLink';
import {Panel} from '../nimbus/panel';
import {LoginForm} from './LoginForm';
import {WithCommonTranslations} from 'components/hocs';
import {TranslationMixin} from 'mixins/translationMixin';
import './Login.css';

export const Login = WithCommonTranslations(
    class extends TranslationMixin(React.Component) {
      constructor(props) {
        super(props);

        this.node = React.createRef();

        this.state = {
          hidden: true,
        };

        this.hide = this.hide.bind(this);
        this.togglePanel = this.togglePanel.bind(this);
        this.handleLoginSuccess = this.handleLoginSuccess.bind(this);
      }

      componentDidMount() {
        this.toggleClickOutsideEvent(true);
      }

      componentWillUnmount() {
        this.toggleClickOutsideEvent(false);
      }

      toggleClickOutsideEvent(enabled) {
        if (enabled) {
          document.addEventListener('click', this.handleClickOutside);
        } else {
          document.removeEventListener('click', this.handleClickOutside);
        }
      }

      handleClickOutside = (event) => {
        if (!this.state.hidden) {
          const node = this.node.current;
          if (!node || !node.contains(event.target)) {
            this.hide();
          }
        }
      };

      hide() {
        this.setState({hidden: true});
      }

      togglePanel() {
        this.setState((prevState) => {
          return {hidden: !prevState.hidden};
        });
      }

      handleLoginSuccess(user){
        return this.props.onLoginSuccess(user).then(()=>{
          this.hide();
        });
      }

      render() {
        const {className, ...otherProps} = this.props;
        const displayClass = ('login-container ' +
            (className ? className : '')).trim();

        return (
            <div className={displayClass} ref={this.node}>
              <NimbusLink href="#" onClick={this.togglePanel}>{this.getTranslation(
                  'LABEL_LOGIN')}</NimbusLink>
              <Panel floating={true} hidden={this.state.hidden}
                     className="login-panel">
                <LoginForm className='login-popover'
                           onLoginSuccess={this.handleLoginSuccess}
                           onLoginFailure={this.props.onLoginFailure}
                           onLinkClick={this.hide}/>
              </Panel>
            </div>
        );
      }
    });

Login.propTypes = {
  onLoginSuccess: PropTypes.func.isRequired,
  onLoginFailure: PropTypes.func.isRequired,
  registrationLink: PropTypes.string,
  forgotPasswordLink: PropTypes.string,
};